/**
 * Design tokens as JS constants for programmatic access.
 * These mirror the CSS custom properties in globals.css.
 */

export const LAYER_TYPE_COLORS = {
  background: "var(--color-layer-background)",
  fill: "var(--color-layer-fill)",
  line: "var(--color-layer-line)",
  symbol: "var(--color-layer-symbol)",
  circle: "var(--color-layer-circle)",
  heatmap: "var(--color-layer-heatmap)",
  "fill-extrusion": "var(--color-layer-fill-extrusion)",
  raster: "var(--color-layer-raster)",
  hillshade: "var(--color-layer-hillshade)",
} as const;

export type LayerType = keyof typeof LAYER_TYPE_COLORS;

export const LAYER_TYPE_ICONS: Record<LayerType, string> = {
  background: "□",
  fill: "◆",
  line: "━",
  symbol: "T",
  circle: "●",
  heatmap: "◎",
  "fill-extrusion": "▦",
  raster: "▨",
  hillshade: "▲",
};

/** Default map viewport for the editor */
export const MAP_DEFAULTS = {
  pitch: 45,
  bearing: 0,
  zoom: 2,
  center: [0, 20] as [number, number],
} as const;

/** Zoom range for the layer stack visualization */
export const ZOOM_RANGE = { min: 0, max: 24 } as const;
